export default __webpack_public_path__ + "static/15-ac54dba690d15554b335538b6ea67e8f.png";